/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdWebFeaturesProfileGetResponseFeature;
(function (FxIdWebFeaturesProfileGetResponseFeature) {
    FxIdWebFeaturesProfileGetResponseFeature["None"] = "None";
    FxIdWebFeaturesProfileGetResponseFeature["ListGames"] = "ListGames";
    FxIdWebFeaturesProfileGetResponseFeature["UnknownDefaultOpenApi"] = "11184809";
})(FxIdWebFeaturesProfileGetResponseFeature || (FxIdWebFeaturesProfileGetResponseFeature = {}));
export function instanceOfFxIdWebFeaturesProfileGetResponseFeature(value) {
    for (const key in FxIdWebFeaturesProfileGetResponseFeature) {
        if (Object.prototype.hasOwnProperty.call(FxIdWebFeaturesProfileGetResponseFeature, key)) {
            if (FxIdWebFeaturesProfileGetResponseFeature[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdWebFeaturesProfileGetResponseFeatureFromJSON(json) {
    return FxIdWebFeaturesProfileGetResponseFeatureFromJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileGetResponseFeatureFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdWebFeaturesProfileGetResponseFeatureToJSON(value) {
    return value;
}
export function FxIdWebFeaturesProfileGetResponseFeatureToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdWebFeaturesProfileGetResponseFeature.js.map